export default {
  methods: {
    initDateFields (fields) {
      fields.forEach(i => {
        this.record[i] = this.record[i] ? new Date(this.record[i]) : null
      })
    }
  }
}
